/**
 * integrations-lib.js
 *
 * Sends provider alerts to #ee-provider-alerts via a Zapier webhook.
 * Each call posts three fields: type, companyName, text.
 */

const WEBHOOK_URL = process.env.REACT_APP_EE_PROVIDER_ALERTS_WEBHOOK

/**
 * Fire-and-forget alert. Silently swallows errors.
 *
 * @param {string} type        – Event identifier e.g. 'admin_added'
 * @param {string} companyName – Provider name
 * @param {string} text        – Human-readable description of the event
 */
async function sendAlert(type, companyName, text) {
    if (!WEBHOOK_URL) {
        console.warn('[integrations-lib] REACT_APP_EE_PROVIDER_ALERTS_WEBHOOK not set — skipping alert.')
        return
    }
    try {
        await fetch(WEBHOOK_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ type, companyName, text }),
        })
    } catch (e) {
        console.warn('[integrations-lib] Failed to send alert:', e)
    }
}

/**
 * Structured once-per-provider events.
 */
export function sendEeProviderAlert({ type, company, ...rest }) {
    const name = company?.name || 'Unknown'

    const texts = {
        provider_created:         `New provider created: ${name}`,
        admin_added:              `Admin user added to ${name}`,
        card_added:               `Payment card added for ${name}`,
        delivery_method_selected: `Delivery method set for ${name}${rest.deliveryMethod ? ` — ${rest.deliveryMethod}` : ''}${rest.weeklyCap ? `, cap ${rest.weeklyCap}/week` : ''}`,
    }

    const text = texts[type] || `${type} — ${name}`
    return sendAlert(type, name, text)
}

/**
 * Drop-in replacement for notifyMilestone() from slackNotify.js.
 */
export function notifyMilestone(providerName, milestone, progress) {
    const text = progress ? `${milestone} (${progress})` : milestone
    return sendAlert('milestone', providerName, text)
}
